import { useEffect, useRef, useState } from 'react'
import BrowserInteractionTime from 'browser-interaction-time'

function useBrowserInteractionTime(threshold: number, idleTimerId = 1, shouldTrack = true) {
  const [active, setActive] = useState<boolean>(true)
  const [tabActive, setTabActive] = useState<boolean>(true)
  const activeRef = useRef(active)

  activeRef.current = active

  useEffect(() => {
    if (!shouldTrack) {
      return () => {
        timer && timer.destroy()
        timer = null
      }
    }
    let timer: BrowserInteractionTime | null
    timer = new BrowserInteractionTime({
      idleTimeoutMs: threshold,
      stopTimerOnTabchange: false,
      browserTabActiveCallbacks: [
        () => {
          setTabActive(true)
        },
      ],
      browserTabInactiveCallbacks: [
        () => {
          setTabActive(false)
        },
      ],
      idleCallbacks: [
        () => {
          if (activeRef.current) {
            setActive(false)
          }
        },
      ],
      activeCallbacks: [
        () => {
          if (!activeRef.current) {
            setActive(true)
          }
        },
      ],
    })
    timer.startTimer()

    return () => {
      timer && timer.destroy()
      timer = null
    }
  // idleTimerId just allows you to reset the timer from outside
  }, [shouldTrack, threshold, idleTimerId])

  return { active, tabActive }
}

export default useBrowserInteractionTime
